module.exports = __webpack_public_path__ + "static/media/logoCity.72a56f89.svg";